"use client"

import { useContext } from "react"
import { Navigate } from "react-router-dom"
import { AuthContext } from "../../context/AuthContext"

const AdminRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useContext(AuthContext)

  if (loading) {
    return <div className="loading-spinner">Loading...</div>
  }

  return isAuthenticated && user && user.role === "admin" ? children : <Navigate to="/" />
}

export default AdminRoute
